import React, { useState, useEffect } from 'react';
import { Container, Grid, Box, Grow, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowDownward, Mouse } from '@mui/icons-material';
import { NavHashLink } from 'react-router-hash-link';
import { styled } from '@mui/material/styles';

import CustomButton from '../../../components/custom-button/CustomButton';

const StyledLink = styled(NavHashLink)(() => ({
  textDecoration: 'none',
  display: 'block',
  color: 'inherit',
  transition: 'color 0.3s',
}));

export default function HomeTitle() {
  const navigate = useNavigate();
  const toDistrictList = () => {
    navigate('/districtList');
  };

  const toChurchList = () => {
    navigate('/churchList');
  };

  const [mouseVisible, setMouseVisible] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setMouseVisible((prevVisible) => !prevVisible);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
    id="home"
      style={{ height: "100vh", paddingTop: "40vh",  background: `url('https://i.pinimg.com/564x/2b/a8/2f/2ba82f4f94b811c039d63c40c627a181.jpg')`, backgroundSize: 'cover',  backgroundPosition: 'center' }}
    >
      <Container maxWidth="lg" sx={{
        backdropFilter: 'blur(5px)', pb: {xs:2, lg: 4}, mr: 80 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={9}>
          <Typography
            sx={{
              fontSize: { xs: 20, sm: 24, lg: 32, xl: 42 },
              p: { xs: 1, md: 3 },
              pb: 0,
              pt: { xs: 0, md: 2, lg: 5 },
              color: 'darkgray',
              justifyContent: 'center',
              justifySelf: 'center',
              textAlign: 'center'
            }}
          >
            በኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ-ክርስቲያን የሰሜን ሸዋ ሀገረ ስብከት የመረጃ አስተዳደር ስርዓት!
          </Typography>
        </Grid>
        <Grid item xs={12} sm={10}>
          <Grid container spacing={3} sx={{ pt: 2 }}>
            <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: { md: 'right', xs: 'center' } }}>
              <CustomButton variant="contained" onClick={toDistrictList} style={{ minWidth: 200 }}>
                የወረዳ ዝርዝር
              </CustomButton>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: { md: 'left', xs: 'center' } }}>
              <CustomButton variant="contained" onClick={toChurchList} style={{ minWidth: 200 }}>
                የቤተ ክርስቲያን ዝርዝር
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={2} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'right', pr: '10%' }}>
          <StyledLink smooth color="darkgray" to="#aggregate">
            <Typography
              style={{ color: 'inherit' }}
              onMouseEnter={() => setMouseVisible(true)}
              onMouseLeave={() => setMouseVisible(false)}
            >
              <Typography sx={{ color: mouseVisible ? 'darkgray' : 'inherit' }}>
                <Mouse />
              </Typography>
              <Typography>
                <Grow in={mouseVisible} sx={{ transformOrigin: '0 0 0' }} {...(mouseVisible ? { timeout: 1000 } : {})}>
                  <ArrowDownward sx={{ fontSize: '24px' }} />
                </Grow>
              </Typography>
            </Typography>
          </StyledLink>
        </Grid>
      </Grid>
      </Container>
      <Box  id="aggregate"/>
    </Box>
  );
}
